import { useState, useEffect, useContext } from "react";
import { UserContext } from "context/user";

const usePremium = () => {
  const { profile } = useContext(UserContext);

  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    if (profile?.tier?.key === "premium") {
      setIsPremium(true);
    }
  }, [profile?.tier?.key]);

  return { isPremium };
};

export default usePremium;
